import { Component } from '@angular/core';
import { DomSanitizer, SafeHtml } from '@angular/platform-browser';


@Component({
  selector: 'app-indirect-solutions',
  templateUrl: './indirect-solutions.component.html',
  styleUrls: ['./indirect-solutions.component.scss']
})
export class IndirectSolutionsComponent {

  constructor(private sanitizer: DomSanitizer) {}

  sanitizeHtml(html: string): SafeHtml {
    return this.sanitizer.bypassSecurityTrustHtml(html);
  }

  // advanceMoullding:any[] = [
  //   {
  //     title: 'Rubber Extrusion​​',
  //     img: 'assets/images/capability/white/rubber_extrusion.jpg',
  //   },
  //   {
  //     title: 'Cryogenic Deflashing​',
  //     img: 'assets/images/capability/white/cryogenic_deflashing.jpg',
  //   },
  //   {
  //     title: 'Metal To Rubber Parts',
  //     img: 'assets/images/capability/white/metal_to_rubber_parts.jpg',
  //   },
  //   {
  //     title: 'Elastomer Calendering​',
  //     img: 'assets/images/placeholder.jpg',
  //   },
  //   {
  //     title: 'Elastomer Moulding',
  //     img: 'assets/images/placeholder.jpg',
  //   },
  //   {
  //     title: 'Plastic To Rubber Bonding​',
  //     img: 'assets/images/placeholder.jpg',
  //   }
  // ]
  safetyppes:any[] = [
    {
      title: 'Eye',
      img: 'assets/images/capability/orange/safety_1.JPG',
      description: 'Chemical, Laser, Welding'
    },
    {
      title: 'Face​​',
      img: 'assets/images/capability/orange/safety_2.JPG',
      description: 'Chemical, Laser, Welding'
    },
    {
      title: 'Ear​',
      img: 'assets/images/capability/orange/safety_3.JPG',
      description: 'Chemical, Laser, Welding'
    },
    {
      title: 'Hand​​​',
      img: 'assets/images/capability/orange/safety_4.JPG',
      description: 'Types of Gloves, Chemical resistant, Leather Palm, Heat resistant, Cut-resistant'
    },
    {
      title: 'Body',
      img: 'assets/images/capability/orange/safety_5.JPG',
      description: 'Types of Body PPE, Safety Jackets, Coveralls, Aprons'
    },
    {
      title: 'Leg​',
      img: 'assets/images/capability/orange/safety_6.JPG',
      description: 'Types of Leg PPE, Leg guard, Safety Shoes- a) Chemical resistant, b) Steel toe boots, c) Aluminium toe with material guard.'
    }
  ] 

  Mro:any[] = [
    {
      "title": "Production Equipment maintenance",
      "content": [
        {
          "img": "assets/images/capability/orange/mro_1.JPG",
          "description": "Mechanical Spares"
        },
        {
          "img": "assets/images/capability/orange/mro_2.JPG",
          "description": "Electrical Spares"
        }
      ]
    },
    {
      "title": "Material Handling maintenance​",
      "content": [
        {
          "img": "assets/images/capability/orange/mro_3.JPG",
          "description": "Robotic Arm"
        },
        {
          "img": "assets/images/capability/orange/mro_4.JPG",
          "description": "Storage Racks"
        }
      ]
    },
    {
      "title": "Infrastructure & Equipment Repairs​",
      "content": [
        {
          "img": "assets/images/capability/orange/mro_5.JPG",
          "description": "AC cleaning"
        },
        {
          "img": "assets/images/capability/orange/mro_6.JPG",
          "description": "Machine Servicing"
        }
      ]
    },
    {
      "title": "Tools & Consumables​​​",
      "content": [
        {
          "img": "assets/images/capability/orange/mro_7.JPG",
          "description": "Drill Set"
        },
        {
          "img": "assets/images/capability/orange/mro_8.JPG",
          "description": "Spray Cleaners"
        },
        // {
        //   "img": "assets/images/capability/orange/mro_9.JPG",
        //   "description": "Welding Rod"
        // }
      ]
    },
  ]

  chemical:any[] = [
    {
      title: 'Industrial Chemicals',
      img: 'assets/images/capability/orange/chemical_1.JPG',
      description: 'Examples- HCL, Ammonia etc Used in Water Treatment plants , STP plants'
    },
    {
      title: 'Lab Chemicals',
      img: 'assets/images/capability/orange/chemical_2.JPG',
      description: 'Examples- Ethanol, Methanol Used for performing Lab tests and quality checks on parts'
    },
    {
      title: 'Synthetic Paints',
      img: 'assets/images/capability/orange/chemical_3.JPG',
      description: 'Used for Walls and infrastructure maintenance'
    },
    {
      title: 'Thinners',
      img: 'assets/images/capability/orange/chemical_4.JPG',
      description: 'Used for thinning down the viscosity of paint or varnish'
    },
  ]

  packaging:any[] = [
    {
      title: 'Corrugated Boxes',
      img: 'assets/images/capability/orange/packding_1.JPG',
     
    },
    {
      title: 'Flexible Packaging',
      img: 'assets/images/capability/orange/packding_2.JPG',
      
    },
    {
      title: 'Rigid Containers',
      img: 'assets/images/capability/orange/packding_3.JPG',
      
    },
    {
      title: 'Protective Packaging',
      img: 'assets/images/capability/orange/packding_4.JPG',
      
    },
    {
      title: 'Sealing and Strapping Machines',
      img: 'assets/images/capability/orange/packding_5.JPG',
    },
    {
      title: 'Wrapping Machines',
      img: 'assets/images/capability/orange/packding_6.JPG',
    },
    {
      title: 'Labeling Machines',
      img: 'assets/images/capability/orange/packding_7.JPG',
    },
    {
      title: 'Filling and Dispensing Equipment',
      img: 'assets/images/capability/orange/packding_8.JPG',
    },
    {
      title: 'Tapes and Adhesives',
      img: 'assets/images/capability/orange/packding_9.JPG',
    },
    {
      title: 'Labels and Tags',
      img: 'assets/images/capability/orange/packding_10.JPG',
    },
    {
      title: 'Cushioning and Void Fill',
      img: 'assets/images/capability/orange/packding_11.JPG',
    },
    {
      title: 'Pallets and Skids',
      img: 'assets/images/capability/orange/packding_12.JPG',
    },
  ]

  furniture:any[] = [
    {
      title: 'Chairs & Tables',
      img: 'assets/images/capability/orange/furniture_1.JPG',
     
    },
    {
      title: 'Cabinets',
      img: 'assets/images/capability/orange/furniture_2.JPG',
      
    },
    {
      title: 'Almirahs',
      img: 'assets/images/capability/orange/furniture_3.JPG',
      
    },
    {
      title: 'Projector',
      img: 'assets/images/capability/orange/furniture_4.JPG',
      
    },
    {
      title: 'Attendance Machines',
      img: 'assets/images/capability/orange/furniture_5.JPG',
    },
    {
      title: 'Stationary',
      img: 'assets/images/capability/orange/furniture_6.JPG',
    },
  ]

  hardware:any[] = [
    {
      title: 'Fasteners',
      img: 'assets/images/capability/orange/hardware_1.JPG',
     
    },
    {
      title: 'Hammers & Pliers',
      img: 'assets/images/capability/orange/hardware_2.JPG',
      
    },
    {
      title: 'Abrasives',
      img: 'assets/images/capability/orange/hardware_3.JPG',
      
    },
    {
      title: 'Chisels',
      img: 'assets/images/capability/orange/hardware_4.JPG',
      
    },
    {
      title: 'Chemicals & Cleaning Cloths',
      img: 'assets/images/capability/orange/hardware_5.JPG',
    },
    {
      title: 'Scrubbers',
      img: 'assets/images/capability/orange/hardware_6.JPG',
    },
    {
      title: 'Hacksaws',
      img: 'assets/images/capability/orange/hardware_7.JPG',
      
    },
    {
      title: 'Cordless Drill',
      img: 'assets/images/capability/orange/hardware_8.JPG',
    },
    {
      title: 'Mops, brooms',
      img: 'assets/images/capability/orange/hardware_9.JPG',
    },
  ]
  

  materialExpertise:any[] = [
    { 'item': '<h4>Consolidations</h4> <p>Consolidation of Commodities</p>'},
    { 'item': '<h4>Negotiations with OEM</h4> <p>Negotiations with OEM Negotiating with the OEMs directly for the Price listed.</p>'},
    { 'item': '<h4>BOM</h4> <p>Plant visits and discussions with customer to understand BOM & buying pattern.</p>'},
    { 'item': '<h4>Rate Contracts</h4> <p>Converting Commodities such as LED, LPG, N02, Lubricants, HSD, Sensors, PLC, Thinner, etc. into Rate Contract.</p>'},
    { 'item': '<h4>Cost Models</h4> <p>Understanding the current cost for customized items i.e., Packaging items (Corrugated box, polybags, wooden pallets etc.)</p>'},
  ]

  static:any[] = [
    { 'item': '<h4>350+</h4> <p>Customer Plants</p>'},
    { 'item': '<h4>2500+</h4> <p>Suppliers</p>'},
    { 'item': '<h4>360+</h4> <p>Categories</p>'},
    { 'item': '<h4>250000+</h4> <p>SKUs</p>'},
  ]

  contract:any[] = [
    { 'item': 'MRO Items Global Contracts with More than 40+ Global Players.'},
    { 'item': 'Cost Synergy Across the World.'},
    { 'item': 'Leverage Global Contracts for Best Pricing.'},
  ]

  benefit: any[] = [
    { icon: 'Tags', item: '<h4>Mulitple Brands</h4> <p>Consolidation of Commodities</p>' },
    { icon: 'ShieldCheck', item: '<h4>Secure Payments</h4> <p>Consolidation of Commodities</p>' },
    { icon: 'Award', item: '<h4>Consistent Quality</h4> <p>Consolidation of Commodities</p>' },
    { icon: 'Clock4', item: '<h4>Timely Deliveries</h4> <p>Consolidation of Commodities</p>' },
    { icon: 'Truck', item: '<h4>On-site Delivery</h4> <p>Consolidation of Commodities</p>' },
    { icon: 'HandCoins', item: '<h4>Cost Saving</h4> <p>Consolidation of Commodities</p>' },
  ];


//   sizeandprecision:any[] = [
//     { 'item': 'Up to 4000 Tonne'}
//   ]
//   advancemouldingtechnique:any[] = [
//      { 'item':'1K/2K/3K/4K - Moulding'},
//      { 'item':'Gas Assisted Injection Moulding'},
//      { 'item':'Blow Moulding'},
//      { 'item':'Slush Moulding'},
//      { 'item':'Thermoforming'},
//      { 'item':'Compression Moulding'}
//   ]
//   inhousetech:any[] = [
//     { 'item':'Manufacturing Feasibility'},
//     { 'item':'Prototyping'},
//     { 'item':'Tool Designing'},
//     { 'item':'Tool Manufacturing'},
//     { 'item':'Moulding'},
//     { 'item':'Prototyping'}
//  ]
}
